<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { DEFAULT_ICON_CONFIGS } from "@icon-park/vue";
const IconConfig = { ...DEFAULT_ICON_CONFIGS, prefix: "icon" };
export default {
  provide() {
    return {
      ICON_CONFIGS: IconConfig,
    };
  },
};
</script>